// Builds the query string for the lots search AJAX request.
//
// Keys MUST be `search[name]` / `search[key][]`, NOT `[search][name]`.
// A leading bracket makes Rack parse the param under the literal key
// "[search]", so `params[:search]` is nil and every filter is silently
// ignored (the search returns all lots). See spec/requests/lots_spec.rb
// and search-query.test.js.
export function buildSearchData(name, filters = []) {
  const pairs = [['search[name]', name]];
  filters.forEach(({ name: key, value }) => {
    pairs.push([`search[${key}][]`, value]);
  });
  return pairs
    .map((pair) => pair.map(encodeURIComponent).join('='))
    .join('&');
}
